<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="10" style="padding-right: 12px">
                <input type="text" v-model="namaPegawai" placeholder="Nama Role" class="inputs-form form-control"/>
            </CCol>
            <CCol sm="2" style="padding-left: 4px">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../../../component/tableRoleMenu'
import {DataApi} from "../../../service/DataApi";
export default {
    components: {
        Tables
    },
    data() {
        return {
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Role', 'Deskripsi'],
            dataTd: ['namaRole', 'deskripsi'],
            styleTable: ['200px', '200px'],
            classReload: 'reloadOff',

            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            namaPegawai: '',
            
            // datas
            datas: [],

            //error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        namaPegawai() {
            this.flagSearch = true
        },
    },
    methods: {
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaRole.toLowerCase() < b.namaRole.toLowerCase()) {
                        return -1
                    }
                    if (a.namaRole.toLowerCase() > b.namaRole.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.deskripsi.toLowerCase() < b.deskripsi.toLowerCase()) {
                        return -1
                    }
                    if (a.deskripsi.toLowerCase() > b.deskripsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let nama = this.namaPegawai

            let payload = {
                limit: limit,
                pageIn: page,
                nama: nama,
            }
            DataApi.post("menu/role/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reset() {
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.namaPegawai = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
</style>